import { Image } from '@chakra-ui/react';

interface FrogBoxLogoProps {
  size?: 'sm' | 'md' | 'lg';
}

export const FrogBoxLogo: React.FC<FrogBoxLogoProps> = ({
  size = 'md',
}) => {
  const height = {
    sm: '24px',
    md: '32px',
    lg: '48px',
  }[size];

  return (
    <Image
      src={`${import.meta.env.BASE_URL}images/frogbox-logo.webp`}
      alt="FrogBox"
      height={height}
      objectFit="contain"
    />
  );
};
